import i18next from "i18next";
import { LANGUAGE, LANGUAGES, PHONE_TYPE, VALIDATIONS, YES_NO, YES_NO_TRANS_KEY } from "../../utils/constants";
import { optionValues, radioOptionValues, todayEndOfDay, translatedRadioOptions, translatedYesNoValues } from "../../utils/utils";

export const getFormFields = (formData, states, t, tv) => {
    const selectedLanguage = i18next.language || "en";
    let yesNoObj = {};
    for (const key in YES_NO) {
        yesNoObj[key] = tv(YES_NO_TRANS_KEY[key])
    }

    const languageOptions = radioOptionValues(LANGUAGES, true).map(option => ({
        ...option,
        label: tv(`${option.id}`) 
    }));
    
    const updatedLanguageOptions = languageOptions.map(option =>
        option.id === LANGUAGES.Other 
            ? { ...option, customRender: true }
            : option
    );
    const noPhoneSelected = Array.isArray(formData?.noPhone) && formData.noPhone.includes("noPhoneNumber");

    let step1Fields = [
        { type: "text", name: "firstName", label: t("firstName"), isRequired: true, maxLength: 35, valid: selectedLanguage === LANGUAGE.Spanish ? VALIDATIONS.String.isSpanishName : VALIDATIONS.String.isName },
        { type: "text", name: "lastName", label: t("lastName"), isRequired: true, maxLength: 35, valid: selectedLanguage === LANGUAGE.Spanish ? VALIDATIONS.String.isSpanishName : VALIDATIONS.String.isName },
        { type: "text", name: "applicationHealthPlanId", label:  t("applicationHealthPlanId"), maxLength: 16 },
        { type: "text", name: "address", label:  t("address"), isRequired: true, maxLength: 35 },
        { type: "text", name: "address2", label:  t("address2"), maxLength: 35 },
        { type: "text", name: "city", label:  t("city"), isRequired: true, maxLength: 50 },
        { type: "options", name: "state", label:  t("state"), optionValues: optionValues(states, !formData.state || formData.state === '', tv('select')), isRequired: true, maxLength: 2, minLength: 2 },
        { type: "number", name: "postalCode", label:  t("postalCode"), isRequired: true, minLength: 5, maxLength: 9, valid: VALIDATIONS.Number.isZipCode },
        { type: "date", name: "birthday", label:  t("birthday"), isRequired: true, maxValue: todayEndOfDay() },
        { type: "email", name: "email", label:  t("email"), maxLength: 255, valid: VALIDATIONS.String.isEmail },
        { type: "tel", name: "phone", label:  t("phone"), isRequired: !noPhoneSelected, disabled: noPhoneSelected, dependsOn: "noPhone", dependsValue: "noPhoneNumber", maxLength: 10, removeSpacing: true, showCustomError: true },
        {
            type: "checkbox",
            name: "noPhone",
            label: "",
            disabled: !!formData?.phone,
            hideLabel: true,
            optionValues: [{ id: "noPhoneNumber", label: "I do not have a phone number", value: "noPhoneNumber" }]
        },
        { type: "radio", name: "phoneType", label: t("phoneType"), optionValues:  translatedRadioOptions(tv, PHONE_TYPE), disabled: noPhoneSelected, dependsOn: "noPhone", dependsValue: "noPhoneNumber" },
        { type: "radio", name: "primaryLanguage", label: t('primaryLanguage'), hasCustomRender: true, customRenders: [LANGUAGES.Other], optionValues: updatedLanguageOptions },
        {
            type: "radio", name: "needTranslator", label: t('needTranslator'), optionValues: translatedYesNoValues(tv)
        },
        { type: "radio", name: "deviceWithInternetAccess", label: t("deviceWithInternetAccess"), optionValues: translatedYesNoValues(tv, [{ id: 'notSure', label: "notSure", value: "notSure" }]) },
        { type: "textarea", name: "participateReason", label: t("participateReason"), maxLength: 255, showCharCounter: true, valid: VALIDATIONS.String.noSpecialChars },
    ];

    let step2Fields = [];

    return {
        step1Fields,
        step2Fields
    }
}
